<mat-icon
  aria-hidden="false"
  aria-label="close"
  style="float: right; margin-top: -1%;"
  (click)="onClicked()"
  fontIcon="close">
</mat-icon>

<div mat-dialog-content>
  
<!-- Loader inferior -->
<div *ngIf="isLoading" style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 2rem;">
  <mat-spinner [diameter]="50" [strokeWidth]="4" color="primary"></mat-spinner>
  <p style="margin-top: 1rem;">Loading document...</p>
</div>


  <!-- Contenido del documento (oculto visualmente pero no destruido) -->
  <div [ngSwitch]="fileType" [style.display]="isLoading ? 'none' : 'block'">
    <img
  *ngSwitchCase="'jpg'"
  [src]="fileUrl"
  (load)="onLoad()"
  style="display: block; width: auto;  height: auto; margin: 0 auto;" />

<img
  *ngSwitchCase="'jpeg'"
  [src]="fileUrl"
  (load)="onLoad()"
  style="display: block; width: auto; height: auto; margin: 0 auto;" />

<img
  *ngSwitchCase="'png'"
  [src]="fileUrl"
  (load)="onLoad()"
  style="display: block; width: auto; height: auto; margin: 0 auto;" />

    <iframe *ngSwitchCase="'pdf'" [src]="fileUrl" width="100%" height="600px"></iframe>
    <p *ngSwitchDefault>Type not supported</p>
  </div>

  

</div>





